import { useTranslation } from 'react-i18next';
import {
    Header, List, Paragraph, StyledHelp,
} from './styled';

const Help = ({ isActive }) => {
    const { t } = useTranslation();

    return (
        <StyledHelp isactive={isActive}>
            <Header>{t('Mata do kodowania - siatka 10 na 10')}</Header>
            <Paragraph>{t('pomocPierwszyParagraf')}</Paragraph>
            <List>
                <li>{t('kolorowe kartoniki - dostępne w 10 kolorach,')}</li>
                <li>{t('kwadraty do kodowania - zawierające litery, cyfry oraz różnorodne symbole.')}</li>
            </List>
            <Paragraph>{t('pomocDrugiParagraf')}</Paragraph>
            <Paragraph>{t('pomocTrzeciParagraf')}</Paragraph>
        </StyledHelp>
    );
};

export default Help;
